
export const APP_VERSION = '1.0.3';
export const APP_VERSION_DEV = '1.0.2';
export const BUILD_DATE = '14-05-2026 10:29:41';
export const BUILD_NUMBER = '140520261029';
